module.exports = __webpack_public_path__ + "ce2d89987f6b487c7401533198a89a74.png";